import { DEPLOY_ENV } from '@base/constants'
import { message } from 'antd'
import { ERROR_MESSAGE } from '../../request'
import './style.scss'

interface ToastProps {
  content: string
  type?: string
  duration?: number
}

message.config({
  prefixCls: 'sr-toast',
  top: 200,
})

function onClose() {
  const node = document.getElementsByClassName('sr-toast')[0]
  if (node?.children[0]?.innerHTML) {
    node.children[0].innerHTML = ''
  }
}

function show(options: ToastProps) {
  const globalLoading = document.querySelector('#global__loading')
  if (globalLoading && globalLoading.classList.contains('show')) {
    return false
  }
  return message.open({
    content: options.content,
    // @ts-ignore
    type: options.type,
    className: `${options.type === 'loading' ? 'custom__loading_container' : 'custom__toast_container'}`,
    duration: options.duration >= 0 ? options.duration : 3,
    onClose,
  })
}

function hide() {
  const globalLoading = document.querySelector('#global__loading')
  if (globalLoading && globalLoading.classList.contains('show')) {
    globalLoading.classList.remove('show')
    return false
  }
  return message.destroy
}

function error(title?: string) {
  return show({
    content: DEPLOY_ENV === 'prod' ? ERROR_MESSAGE : title,
  })
}

function loading(title = '') {
  return show({
    content: title,
    type: 'loading',
    duration: 0,
  })
}

const toast = {
  hide,
  show,
  loading,
  error,
  onClose,
}

export default toast
